import React from "react";
import { Row } from "antd";

import PageContainer from "../layout/PageContainer";
import styles from "./CompanyInfo.module.css";

function CompanyInfo() {
    const info = [
        {
            title: "상호",
            info: "주식회사 루타스",
        },
        {
            title: "대표",
            info: "허성만",
        },
        {
            title: "주소",
            info: "대구광역시 달성군 구지면 국가산단서로71길 81, D동",
        },
        {
            title: "사업자등록번호",
            info: "362-81-01755",
        },
        {
            title: "대표번호",
            info: "053-719-0510",
        },
        {
            title: "고객센터(평일 9:00 - 17:00)",
            info: "070-7707-1768",
        },
        {
            title: "이메일",
            info: "support@rutas.co.kr",
        },
    ];

    return (
        <PageContainer pageBackground={"white"} contentPadding={16}>
            <Row align="middle" justify="center">
                <div className="container">
                    {info.map((item) => (
                        <div key={item.title} className={styles.card}>
                            <p className={styles.title}>{item.title}</p>
                            <p className={styles.info}>{item.info}</p>
                        </div>
                    ))}
                </div>
            </Row>
        </PageContainer>
    );
}

export default CompanyInfo;
